import axios from 'axios'
import Vue from 'vue'
import * as Cookies from 'tiny-cookie'
import { eventbus } from './eventbus'

// Konfiguration
const cloudServers = ['web.nexabridge.se', 'localhost', 'web.nexa.se']

/** **/
const host = window.location.hostname
const bridgeId = Cookies.get('bridgeId')
const isCloud = cloudServers.includes(host)

let httpObj = {
  //timeout: 5000
}

// Är det en molnservern?
if (isCloud) {
  httpObj.baseURL = 'https://bridge.nexa.se:8443/cloudserver/gw/' + bridgeId + '/v1'
  httpObj.headers = {
    Authorization: 'Basic ' + Cookies.get('hash')
  }
} else {
  // Används när vi skall ansluta lokalt till Bridgen, alltså när man
  // går in på den direkt och inte via någon annan tjänst.
  httpObj.baseURL = 'http://' + host + '/basic/'
}

export const HTTP2 = axios.create(httpObj)

/*
  Nedanstående fångar upp alla svar från APiet och kollar
  om vi är på molnet och om vi är det måste vi validera svaret,
  ex. kolla så att Bridgen är ansluten, etc.
*/
let didGetError = false
HTTP2.interceptors.response.use((response) => {
  // Kolla så att vi faktiskt är på molne
  if (isCloud) {
    // Kolla om vi har fått svar från servern som kan indikera att
    // någonting är fel med datan.
    if (('cloudResult' in response.data) && !didGetError) {
      eventbus.$emit('error', {
        text: 'Ett fel uppstod vid anslutningen till molnet',
        subject: response.data.cloudResult
      })

      didGetError = true
    }
  }

  return response;
}, (error) => {
  return Promise.reject(error)
})


/**
  Fångar upp anrop som görs, kollar om vi är på molnet och isåfall lägger
  vi på en timeout på 3500s. Detta är timeouten mellan molnet och bridgen,
  inte timeouten mellan webbläsaren och servern.
*/
HTTP2.interceptors.request.use((config) => {
  const timeout = 20000
  
  if (isCloud) {
    if (config.url.includes('?')) {
      config.url = config.url + '&timeout=' + timeout
    } else {
      config.url = config.url + '?timeout=' + timeout
    } 
  }
  
  
  return config;
}, (error) => {
  // Do something with request error
  return Promise.reject(error);
})


export const cloud = axios.create({
  baseURL: 'https://bridge.nexa.se:8443/cloudserver/',
  headers: {
    Authorization: 'Basic ' + Cookies.get('hash')
  }
})


// WEBPACK FOOTER //
// ./src/http2.js